import { API_BASE } from '../config/api';

const scopeConfig = {
  community: {
    basePath: (id) => `${API_BASE}/api/communities/${id}`,
  },
  organization: {
    basePath: (id) => `${API_BASE}/api/organizations/${id}`,
  },
  club: {
    basePath: (id) => `${API_BASE}/api/clubs/${id}`,
  },
};

const handleResponse = async (response, fallbackMessage = 'Unable to load player approvals.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || fallbackMessage);
  }

  return data;
};

const getScopeBase = (scopeType, scopeId) => {
  const config = scopeConfig[scopeType];
  if (!config || !scopeId) {
    throw new Error('A valid scope is required to manage player approvals.');
  }

  return config.basePath(scopeId);
};

const buildActiveContextHeaders = (contextType, entityType, entityId) => ({
  'x-active-context-type': contextType,
  'x-active-entity-type': entityType,
  'x-active-entity-id': entityId,
});

export const fetchScopedPlayersByStatus = async ({
  scopeType,
  scopeId,
  contextType,
  entityType,
  entityId,
  status = 'pending',
  token,
}) => {
  const base = getScopeBase(scopeType, scopeId);
  const response = await fetch(`${base}/players/pending?status=${encodeURIComponent(status)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...buildActiveContextHeaders(contextType, entityType, entityId),
    },
  });

  return handleResponse(response, 'Unable to load players for this approval queue.');
};

export const updateScopedPlayerApproval = async ({
  scopeType,
  scopeId,
  contextType,
  entityType,
  entityId,
  playerId,
  action,
  token,
}) => {
  if (!['approve', 'reject'].includes(action)) {
    throw new Error('Approval action must be approve or reject.');
  }

  const base = getScopeBase(scopeType, scopeId);
  const response = await fetch(`${base}/players/${playerId}/${action}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      ...buildActiveContextHeaders(contextType, entityType, entityId),
    },
  });

  return handleResponse(response, 'Unable to update player approval status.');
};
